import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';
import { TabSdk } from '@techextensor/tab-sdk';

/**
 * Guard that redirects to the appropriate app code URL.
 * Extracts app code from session storage, URL, or environment config.
 * @returns UrlTree with the correct app code path
 */
export const appCodeRedirectGuard: CanActivateFn = (): UrlTree => {
    const router = inject(Router);
    if (TabSdk.store?.appName != null && TabSdk.store?.appName != undefined && TabSdk.store?.appName != '') {
        return router.createUrlTree([TabSdk.store.appName + '/screen/']);
    } else {
        return router.createUrlTree([environment.commonConfig.applicationCode + '/screen/']);
    }
};